import { cn } from "@/core/helpers/cn";

type Props = {
  className?: string;
  percent: number;
};

export default function ProgressBar({ className, percent }: Props) {
  return (
    <div className={cn("relative bg-[#191919] h-1 rounded-[0.625rem] overflow-clip", className)}>
      <div
        className="absolute bg-gradient-to-r from-accent-muted to-accent-solid top-0 left-0 right-0 bottom-0"
        style={{
          clipPath: `polygon(0 0, ${percent}% 0,  ${percent}% 100%, 0 100%)`,
        }}
      />
    </div>
  );
}
